import { render } from "./todo-modal.vue?vue&type=template&id=38fdf78b"
import script from "./todo-modal.vue?vue&type=script&lang=js"
export * from "./todo-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__